import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Icon } from '../../ui/Icon';
import { rem } from '../../utils';
export const StyledPillCarousel = styled.div `
  position: relative;
  width: 100%;
`;
export const PillList = styled.div `
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scroll-margin-left: ${rem(22)};
  scroll-padding: 50%;
  ${({ theme }) => theme.Scrollbar.Panel}
`;
export const PillWrapper = styled.div `
  margin-right: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  scroll-snap-align: center;

  &:last-child {
    margin-right: 0;
  }
`;
export const ButtonStyle = styled.a `
  position: absolute;
  width: 22px;
  height: 100%;
  top: 0;
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Elevated +
    `; background: linear-gradient(
    90deg,
    ${theme.Components.Panel.Background} 65.62%,
    rgba(255, 255, 255, 0) 100%
  );`};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity ${({ theme }) => theme.Transition.Timing.Out};
  cursor: pointer;

  svg {
    position: absolute;
    width: 22px;
    height: 32px;
    top: 0;
    transform: rotate(180deg);
  }
`;
export const Controller = ({ className, visible, onClick, }) => (_jsx(ButtonStyle, { visible: visible, className: className, onClick: onClick, children: _jsx(Icon, { name: 'chevron---right' }) }));
export const PreviousController = styled(Controller) `
  left: 0;

  svg {
    left: 0;
  }
`;
export const NextController = styled(Controller) `
  right: 0;
  transform: matrix(-1, 0, 0, 1, 0, 0);

  svg {
    right: 0;
  }
`;
//# sourceMappingURL=PillCarousel.style.js.map